import type {ReactAction} from '@netx/core/bootstrap';
import {faCompress} from '@fortawesome/pro-solid-svg-icons';
import {canManageCurrentCartRelationships} from '../enablers';
import {CART_CURRENT_ACTION_LABELS} from '../locales';
import {CART_CURRENT_EVENT} from './constants';

/**
 * Link cart asset relationships
 * @param params
 * @returns Action
 */
export const cartActionManageRelationshipsLink = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'cart-current-manage-relationships-link',
	cb: () => dispatcher.trigger(CART_CURRENT_EVENT.RELATIONSHIPS_LINK),
	enableTest: canManageCurrentCartRelationships,
	icon: faCompress,
	get label() {
		return CART_CURRENT_ACTION_LABELS.RELATIONSHIPS_LINK;
	},
	...params,
});

export default cartActionManageRelationshipsLink;
